<template>
  <div class="file-condition-finding">
    <el-form :model="findForm" ref="findForm" label-width="100px" class="find-form" :inline="true">
      <el-form-item label="业务线">
        <el-select v-model="findForm.lineId" placeholder="请选择业务线" filterable>
          <el-option v-for="item in lineList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="负责人">
        <el-select v-model="findForm.managerId" placeholder="请选择平台负责人" clearable filterable remote :remote-method="getUserList" :loading="loading">
          <el-option v-for="item in userList" :key="item.userId" :label="item.fullName" :value="item.userId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建人">
        <el-select v-model="findForm.createrId" placeholder="请选择平台创建人" clearable filterable remote :remote-method="getUserList" :loading="loading">
          <el-option v-for="item in userList" :key="item.userId" :label="item.fullName" :value="item.userId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="findForm.isReject" placeholder="请选择平台状态" filterable>
          <el-option label="全部" value=''></el-option>
          <el-option label="正常" :value="false"> </el-option>
          <el-option label="删除" :value="true"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="名称标识">
        <el-input v-model="findForm.searchStr" class="form-input" placeholder="请输入平台名称或标识" @keydown.enter.native="getPlatformList"></el-input>
      </el-form-item>
      <el-form-item align="center">
        <el-button type="primary" @click="getPlatformList">搜索</el-button>
        <el-button @click="resetForm('findForm')">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="find-file-container">
      <el-table :data="tableData" style="width: 100%" :max-height="450" :height="450" :highlight-current-row="true" @row-dblclick="getPlatformInfo" title="双击查看平台详情">
        <div slot="empty" class="empty-content empty-image">
          <p class="empty-text">暂无数据哦~</p>
        </div>
        <el-table-column label="业务线" prop="name" show-overflow-tooltip min-width="180px" align="left">
          <template v-slot="{row}">
            {{row.lineInfo.name}}
          </template>
        </el-table-column>
        <el-table-column label="logo" prop="name" show-overflow-tooltip min-width="180px" align="left">
          <template v-slot="{row}">
            <img class="logo" :src="row.logo" fit="contain" />
          </template>
        </el-table-column>
        <el-table-column label="名称" prop="name" show-overflow-tooltip min-width="150px" align="left">
        </el-table-column>
        <el-table-column label="标识" prop="slug" align="center" min-width="100px">
        </el-table-column>
        <el-table-column label="负责人" prop="managerName" align="center" min-width="120px">
        </el-table-column>
        <el-table-column label="状态" prop="isReject" min-width="150px" align="center">
          <template v-slot="{row}">
            <el-tag v-if="!row.isReject" type="success">正常</el-tag>
            <el-tag v-else type="danger">删除</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="用户鉴权方式" prop="isReject" min-width="150px" align="center">
          <template v-slot="{row}">
            <el-tag v-if="row.authType==='kylin'" type="danger">麒麟</el-tag>
            <el-tag v-else type="warning">电商</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="OSS类型" prop="type" align="center" min-width="150px">
          <template v-slot="{row}">
            <el-tag v-if="row.type==='aliCloud'" type="warning">阿里云</el-tag>
            <el-tag v-if="row.type==='tencentCloud'" type="primary">腾讯云</el-tag>
            <el-tag v-if="row.type==='jdCloud'" type="danger">京东云</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="存储桶" prop="bucket" min-width="200px">
        </el-table-column>
        <el-table-column label="存储桶区域" prop="bucketRegion" min-width="150px">
        </el-table-column>
        <el-table-column label="CDN加速域名" prop="cdn" min-width="200px">
        </el-table-column>
        <el-table-column label="创建人" prop="createrName" align="center" min-width="120px">
        </el-table-column>
        <el-table-column label="平台描述" prop="desc" min-width="300px" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime" width="150px">
          <template v-slot="{row}">
            {{row.createTime?formatTime(row.createTime):''}}
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="updateTime" width="150px">
          <template v-slot="{row}">
            {{row.updateTime?formatTime(row.updateTime):''}}
          </template>
        </el-table-column>
        <el-table-column align="center" fixed="right" min-width="150px">
          <template slot="header">
            <el-input v-model="search" size="mini" placeholder="输入关键字搜索" />
          </template>
          <template v-slot="{row}">
            <el-button v-if="!row.isReject" type="text" :disabled="(row.createrId!==userInfo.id||row.managerId!==userInfo.id)&&!userInfo.isAdmin" @click="showEditForm(row)">编辑</el-button>
            <el-button v-if="!row.isReject" type="text" :disabled="(row.createrId!==userInfo.id||row.managerId!==userInfo.id)&&!userInfo.isAdmin" @click="delPlatform(row.slug)">删除</el-button>
            <el-button v-if="row.isReject" type="text" :disabled="(row.createrId!==userInfo.id||row.managerId!==userInfo.id)&&!userInfo.isAdmin" @click="rePlatform(row.slug)">恢复</el-button>
          </template>

        </el-table-column>
      </el-table>

      <el-pagination class="find-container-pager" @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="pageConfig.pageNum" :page-sizes="[10, 50, 100, 200]" :page-size="pageConfig.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" :pager-count="5">
      </el-pagination>

      <!-- 对话框 -->
      <el-dialog :append-to-body='true' :top="dialog.top" :title="dialog.title" :visible.sync="dialog.visible" :width="dialog.width" :before-close="destroyComponent">
        <component :is="dialog.component" @close="destroyComponent" :isEdit="true" :platformInfo="platformInfo" @getPlatformList="getPlatformList" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { userApi, lineApi, platformApi } from '@/api/index';
import { showLoading, hideLoading } from '@/plugins/loading';
import { mapGetters } from 'vuex';
import { dialogMixin } from "@/common/mixins/";
import platformApply from './platformApply.vue';
import platformInfo from './platformInfo.vue';
import dayjs from 'dayjs';
export default {
  name: 'platform-list',
  mixins: [dialogMixin],
  data () {
    return {
      findForm: {
        lineId: '',
        searchStr: '',
        managerId: '',
        createrId: '',
        isReject: ''
      },
      pageConfig: {
        pageNum: 1,
        pageSize: 10
      },
      search: '',
      total: 0,
      loading: false,
      findList: [],
      userList: [],
      lineList: [],
      platformInfo: ''
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    tableData () {
      return this.findList.filter(data => !this.search || data.name.toLowerCase().includes(this.search.toLowerCase()));
    }
  },
  mounted () {
    this.getLineList();
    this.getPlatformList();
  },
  methods: {
    // 显示平台信息弹窗
    showPlatformInfo (data) {
      this.platformInfo = data;
      this.setDialog(true, "平台详情", platformInfo, "900px", "15vh");
    },
    // 显示修改弹窗
    showEditForm (data) {
      this.platformInfo = data;
      this.setDialog(true, "信息修改", platformApply, "1100px", "5vh");
    },
    // 销毁动态组件
    destroyComponent () {
      this.setDialog(false, "", null, "1100px", "1vh");
    },
    // 获取业务线列表
    async getLineList () {
      const res = await lineApi.getLineList();
      if (res.code === 200) {
        this.lineList = res.data
      } else {
        this.$message.error(res.message);
      }
    },
    // 获取平台信息
    async getPlatformInfo (row) {
      platformApi.getPlatformInfo({ slug: row.slug });
      this.showPlatformInfo(row)
    },
    // 删除平台信息
    delPlatform (slug) {
      this.$confirm(`是否确认删除`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = { slug }
        const res = await platformApi.delPlatform(params);
        if (res.code === 200) {
          this.getPlatformList();
          this.$message.success('删除成功！');
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 恢复平台信息
    rePlatform (slug) {
      this.$confirm(`是否确认恢复`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = { slug }
        const res = await platformApi.rePlatform(params);
        if (res.code === 200) {
          this.getPlatformList();
          this.$message.success('恢复成功！');
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消恢复'
        });
      });
    },
    // 获取业务线列表
    async getPlatformList () {
      showLoading();
      const res = await platformApi.getPlatformList({ ...this.findForm, ...this.pageConfig });
      if (res.code === 200) {
        this.findList = res.data.rows;
        this.total = res.data.count;
      } else {
        this.$message.error(res.message);
      }
      hideLoading();
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    },
    // 格式化时间
    formatTime (time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
    // 当当前页数改变，触发事件
    handlePageChange (num) {
      this.pageConfig.pageNum = num;
      this.getPlatformList();
    },
    // 当页面显示数据总数改变，触发事件
    handleSizeChange (size) {
      this.pageConfig.pageSize = size;
      this.getPlatformList();
    },
    // 获取用户列表
    getUserList (realName) {
      this.loading = true;
      setTimeout(async () => {
        this.loading = false
        const res = await userApi.getUserList({ realName })
        this.userList = res.userInfo
      }, 200);
    },
  }
}
</script>

<style lang="scss" scoped>
.file-condition-finding {
  .form-input {
    width: 400px;
  }
  .find-file-container {
    position: relative;
    height: 500px;
    .empty-content {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      width: 100%;
      height: 360px;
      background-image: url("https://front-xps-cdn.xsyx.xyz/2021/10/22/1737927985.png");
      background-repeat: no-repeat;
      background-size: auto 100%;
      background-position: center;
      .empty-text {
        font-weight: 500;
        color: #bcbcbc;
      }
    }
    .logo {
      max-height: 40px;
    }
    .empty-text.other-text {
      position: relative;
      top: 40px;
    }
    .find-container-pager {
      margin-top: 10px;
      text-align: center;
    }
  }
  .file-content {
    display: flex;
    justify-content: left;
    align-items: center;
    .file-name {
      min-width: 180px;
    }
    .file-image {
      display: inline-block;
      margin-right: 20px;
      min-width: 40px;
      max-height: 40px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      &.file-icon {
        height: 40px;
      }
    }
  }
  .table-cdn {
    cursor: pointer;
    &:hover {
      color: #409eff;
    }
  }
}
</style>